import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { EIconSize, Icon } from '@frontend/pole-ui/lib/components/Icon'
import { NewMessageFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/NewMessageFillIcon'
import { OpenMessageFillIcon } from '@frontend/pole-ui/lib/components/Icon/svg/OpenMessageFillIcon'
import cn from 'classnames'
import { EUserProfileRoute } from '@/types'
import { ESaleRequestType } from '@/types/ESaleRequestType'
import { useFormatDate } from '@/utils/hooks/format/useFormatDate'
import { parseRequestLink } from './helpers'
import type { IRequestLink, NotificationLinkParserProps } from './types'
import './notifications.scss'

export const renderTextWithLinks = (text: string, links: IRequestLink[]): React.ReactNode[] => {
  return text.split(/(\{\{LINK_\d+\}\})/).map(part => {
    const linkMatch = part.match(/\{\{LINK_(\d+)\}\}/)

    if (linkMatch?.[1]) {
      const linkIndex = parseInt(linkMatch[1], 10)
      const link = links[linkIndex]

      if (!link) {
        return part
      }

      const routeSegment = ESaleRequestType[link.type]
      const url = link.id ? `${EUserProfileRoute.sales}/${link.id}/${routeSegment}` : EUserProfileRoute.sales

      return (
        <CommonLink className="notificationLinkParser__link" url={url}>
          {link.displayText}
        </CommonLink>
      )
    }

    return part
  })
}

export const NotificationLinkParser = (props: NotificationLinkParserProps) => {
  const {
    notification: { title, body = '', createDate, read },
  } = props
  const { formatDate } = useFormatDate()

  const [notificationTime, notificationDate] = formatDate(createDate, 'HH:mm;d MMMM yyyy').split(';')
  const { parsedText: parsedTitle, links: titleLinks } = parseRequestLink(title)
  const { parsedText: parsedBody, links: bodyLinks } = parseRequestLink(body)

  return (
    <div className={cn('notificationLinkParser space-holder2-sm', { notificationLinkParser__unread: !read })}>
      <div className="notificationLinkParser__icon">
        <Icon component={read ? <NewMessageFillIcon /> : <OpenMessageFillIcon />} size={EIconSize.M} />
      </div>
      <div>
        <div className="space-holder8">{renderTextWithLinks(parsedTitle, titleLinks)}</div>
        <p className="notificationLinkParser__body text_super-small color_pale-black">{renderTextWithLinks(parsedBody, bodyLinks)}</p>
        <div className="notificationLinkParser__date space-holder-top16 text_super-small color_pale-black">
          <span>{notificationTime}</span>
          <span>{notificationDate}</span>
        </div>
      </div>
    </div>
  )
}
